import { Sagas } from './types'

import catalogFilterSagas from './catalog-filters/sagas'
import conversationSagas from './conversation/sagas'
import { sagas as checkoutSagas } from './checkout'
import locationSagas from './location/sagas'
import itemUploadSagas from './item-upload/sagas'
import bannersSagas from './banners/sagas'
import packageSizesSagas from './package-sizes/sagas'
import businessAddressesSagas from './business-addresses/sagas'
import systemConfigurationSagas from './system-configuration/sagas'
import returnShipmentSagas from './return-shipment/sagas'

export const getStaticSagas = (): Sagas => []

export const getCoreSagas = (): Sagas => [
  catalogFilterSagas(),
  conversationSagas(),
  checkoutSagas(),
  locationSagas(),
  itemUploadSagas(),
  bannersSagas(),
  packageSizesSagas(),
  businessAddressesSagas(),
  systemConfigurationSagas(),
  returnShipmentSagas(),
]

export { default as businessAccountsSaga } from './business-accounts/sagas'
